import React, { useContext, useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";
import Img1 from "../../assets/image/hero-section.jpg";
import Img2 from "../../assets/image/hero-section2.png";
import Img3 from "../../assets/image/hero-section3.png";
import { AuthContext } from "../../context/AuthContext";

function HeroSection() {
	const [currentIndex, setCurrentIndex] = useState(0);
	const [direction, setDirection] = useState(0);
	const images = [Img1, Img2, Img3];
	const { user } = useContext(AuthContext);

	useEffect(() => {
		const timer = setInterval(() => {
			setDirection(1);
			setCurrentIndex((prev) => (prev + 1) % images.length);
		}, 3000);
		return () => clearInterval(timer);
	}, [currentIndex]);

	const slideVariants = {
		enter: (direction) => ({
			x: direction > 0 ? 1000 : -1000,
			opacity: 0,
		}),
		center: {
			zIndex: 1,
			x: 0,
			opacity: 1,
		},
		exit: (direction) => ({
			zIndex: 0,
			x: direction < 0 ? 1000 : -1000,
			opacity: 0,
		}),
	};

	return (
		<div className="flex flex-col justify-center items-center w-full lg:py-2">
			<div className="flex justify-center items-center w-full mb-10">
				<div className="relative w-full h-[80vh] lg:mx-14 mx-5 rounded-2xl overflow-hidden">
					<AnimatePresence initial={false} custom={direction}>
						<motion.div
							key={currentIndex}
							custom={direction}
							variants={slideVariants}
							initial="enter"
							animate="center"
							exit="exit"
							transition={{
								x: {
									type: "spring",
									stiffness: 300,
									damping: 30,
								},
								opacity: { duration: 0.2 },
							}}
							className="absolute inset-0"
							style={{
								backgroundImage: `url(${images[currentIndex]})`,
								backgroundSize: "cover",
								backgroundPosition: "center",
								backgroundRepeat: "no-repeat",
								backgroundColor: "#000",
							}}
						/>
					</AnimatePresence>

					<div className="absolute inset-0 bg-black bg-opacity-50 z-10" />

					{/* Decorative dots */}
					<div className="absolute w-2 h-2 top-60 left-32 bg-white blur-sm rounded-full z-10" />
					<div className="absolute w-2 h-2 top-80 left-10 bg-white blur-sm rounded-full z-10" />
					<div className="absolute w-2 h-2 top-96 left-40 bg-white blur-sm rounded-full z-10" />
					<div className="absolute w-2 h-2 top-60 right-20 bg-white blur-sm rounded-full z-10" />
					<div className="absolute w-2 h-2 top-80 right-60 bg-white blur-sm rounded-full z-10" />
					<div className="absolute w-2 h-2 top-96 right-32 bg-white blur-sm rounded-full z-10" />

					{/* Content */}
					<div className="absolute inset-0 z-10 flex flex-col items-center justify-center text-center text-white">
						<div className="mt-6 text-xs px-12 py-3 rounded-full backdrop-blur-md border-white border border-opacity-60 shadow-md">
							Academy-nest
						</div>
						<h1 className="lg:text-5xl md:text-4xl text-3xl lg:w-7/12 w-10/12 mt-8 leading-snug">
							Your Gateway to Personalized Online Education
						</h1>
						<p className="text-sm font-light mt-6 md:w-2/4 w-3/4 text-gray-100">
							Join millions transforming their careers through
							flexible, expert-led online education.
						</p>
						{user ? (
							<Link
								to=""
								className="bg-white text-blue-700 lg:text-sm text-xs font-medium px-12 py-3 rounded-full shadow-md hover:bg-gray-200 transition mt-6"
							>
								Welcome Back
							</Link>
						) : (
							<Link
								to="/auth"
								className="bg-white text-blue-700 lg:text-sm text-xs font-medium px-12 py-3 rounded-full shadow-md hover:bg-gray-200 transition mt-6"
							>
								Signup
							</Link>
						)}
					</div>

					{/* Slide indicators */}
					<div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex gap-2 z-10">
						{images.map((_, index) => (
							<button
								key={index}
								onClick={() => setCurrentIndex(index)}
								className={`w-2 h-2 rounded-full ${
									currentIndex === index
										? "bg-white"
										: "bg-white/50"
								}`}
							/>
						))}
					</div>
				</div>
			</div>
		</div>
	);
}

export default HeroSection;
